"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useAnalyticsData = require("./useAnalyticsData");
Object.keys(_useAnalyticsData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useAnalyticsData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useAnalyticsData[key];
    }
  });
});
var _useCloseEvents = require("./useCloseEvents");
Object.keys(_useCloseEvents).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useCloseEvents[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useCloseEvents[key];
    }
  });
});
var _useDialogMode = require("./useDialogMode");
Object.keys(_useDialogMode).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useDialogMode[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useDialogMode[key];
    }
  });
});
var _useOpenEvent = require("./useOpenEvent");
Object.keys(_useOpenEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useOpenEvent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useOpenEvent[key];
    }
  });
});
var _useProduct = require("./useProduct");
Object.keys(_useProduct).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useProduct[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useProduct[key];
    }
  });
});
var _useProducts = require("./useProducts");
Object.keys(_useProducts).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useProducts[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useProducts[key];
    }
  });
});
var _useReplaceSubscriptionData = require("./useReplaceSubscriptionData");
Object.keys(_useReplaceSubscriptionData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useReplaceSubscriptionData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useReplaceSubscriptionData[key];
    }
  });
});
var _useSharedConfiguration = require("./useSharedConfiguration");
Object.keys(_useSharedConfiguration).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useSharedConfiguration[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useSharedConfiguration[key];
    }
  });
});
